import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_2 = {
  class: "modal fade",
  id: "showDetailsAdmin",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Print")
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_10 = { class: "modal-body bg-light" }
const _hoisted_11 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "flex-grow-1" }
const _hoisted_14 = { class: "invoice-logo" }
const _hoisted_15 = { class: "invoice-address" }
const _hoisted_16 = { class: "uppercase-text" }
const _hoisted_17 = { class: "flex-shrink-0 mt-sm-0 mt-3" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "text-muted uppercase-text" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = { class: "text-muted uppercase-text" }
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "text-muted uppercase-text" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "mt-4" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "mt-3 border p-2" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "to-upper" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_39 = { class: "table table-borderless mb-0" }
const _hoisted_40 = { class: "table-primary nowrap-text" }
const _hoisted_41 = { class: "table-active" }
const _hoisted_42 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_43 = { scope: "col" }
const _hoisted_44 = { scope: "col" }
const _hoisted_45 = { scope: "col" }
const _hoisted_46 = {
  scope: "col",
  class: "to-upper"
}
const _hoisted_47 = { scope: "col" }
const _hoisted_48 = { scope: "col" }
const _hoisted_49 = { scope: "col" }
const _hoisted_50 = {
  scope: "col",
  class: "text-end to-upper"
}
const _hoisted_51 = {
  colspan: "8",
  class: "pb-0"
}
const _hoisted_52 = { class: "mb-0" }
const _hoisted_53 = { class: "ps-3" }
const _hoisted_54 = { class: "desc-wrap" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "text-end" }
const _hoisted_58 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_59 = { class: "row justify-content-end" }
const _hoisted_60 = { class: "col-lg-3 col-md-9" }
const _hoisted_61 = { class: "total-box" }
const _hoisted_62 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_63 = { scope: "row" }
const _hoisted_64 = { class: "text-end" }
const _hoisted_65 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_66 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_67 = { class: "mb-0" }
const _hoisted_68 = { class: "uppercase-text" }
const _hoisted_69 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_70 = {
  key: 0,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_71 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_72 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_73 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_74 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_75 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_76 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_77 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_78 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_79 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_80 = { class: "alert alert-info mt-3" }
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = { class: "mb-0" }
const _hoisted_83 = /*#__PURE__*/_createVNode("strong", null, " Channel: ", -1)
const _hoisted_84 = { class: "card d-block mt-3" }
const _hoisted_85 = { class: "card-head pb-3" }
const _hoisted_86 = { class: "card-title" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_89 = { class: "signature-wrap my-2" }
const _hoisted_90 = { class: "signature-wrap my-2" }
const _hoisted_91 = { class: "to-upper" }
const _hoisted_92 = { class: "modal-footer" }
const _hoisted_93 = /*#__PURE__*/_createVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_94 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_95 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (_ctx.state.data.details.pdf_link)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "btn default-btn mr-2",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                }, [
                  _hoisted_6,
                  _hoisted_7
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.details.pdf_link)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline to-upper",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                }, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailsCloseAdmin())),
              title: "close"
            }, [
              _hoisted_9
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    (_ctx.state.data.details.logo || _ctx.state.data.companyInfo.logo)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: _ctx.state.data.details.logo ? _ctx.state.data.details.logo : _ctx.state.data.companyInfo.logo,
                          alt: ""
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("p", _hoisted_16, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('address')), 1)
                    ]),
                    _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('email')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_email), 1)
                  ]),
                  _createVNode("p", null, [
                    _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('contact_no')) + ":", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.state.data.companyInfo.company_phone_number), 1)
                  ])
                ])
              ]),
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _createVNode("div", _hoisted_22, [
                  _createVNode("p", null, [
                    _createVNode("strong", _hoisted_23, _toDisplayString(_ctx.$t('estimation_title')), 1)
                  ]),
                  _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("p", null, [
                    _createVNode("strong", _hoisted_25, _toDisplayString(_ctx.$t('estimation_no')), 1)
                  ]),
                  _createVNode("p", null, "#" + _toDisplayString(_ctx.state.data.details.no), 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("p", null, [
                    _createVNode("strong", _hoisted_27, _toDisplayString(_ctx.$t('date')), 1)
                  ]),
                  (_ctx.state.data.details.modifiedCreatedDate)
                    ? (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(_ctx.state.data.details.modifiedCreatedDate), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_29, _toDisplayString(_ctx.state.data.details.created_date), 1))
                ])
              ]),
              _createVNode("div", _hoisted_30, [
                (_ctx.state.data.details && _ctx.state.data.details.customers && _ctx.state.data.details.customers.length)
                  ? (_openBlock(), _createBlock("p", _hoisted_31, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_32, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.customers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4",
                      key: customerIndex
                    }, [
                      _createVNode("div", _hoisted_33, [
                        (customer.first_name || customer.last_name)
                          ? (_openBlock(), _createBlock("p", _hoisted_34, [
                              _createVNode("strong", _hoisted_35, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                              _createTextVNode(_toDisplayString(customer.first_name) + " " + _toDisplayString(customer.last_name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (customer.email)
                          ? (_openBlock(), _createBlock("p", _hoisted_36, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(customer.email), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (customer.phone)
                          ? (_openBlock(), _createBlock("p", _hoisted_37, [
                              _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                              _createTextVNode(" " + _toDisplayString(customer.phone), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode("table", _hoisted_39, [
                  _createVNode("thead", _hoisted_40, [
                    _createVNode("tr", _hoisted_41, [
                      _createVNode("th", _hoisted_42, _toDisplayString(_ctx.$t('item')), 1),
                      _createVNode("th", _hoisted_43, _toDisplayString(_ctx.$t('description')), 1),
                      _createVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('unit')), 1),
                      _createVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('qty')), 1),
                      _createVNode("th", _hoisted_46, _toDisplayString(_ctx.$t('cost')), 1),
                      _createVNode("th", _hoisted_47, _toDisplayString(_ctx.$t('sub_total')), 1),
                      _createVNode("th", _hoisted_48, _toDisplayString(_ctx.$t('markup')), 1),
                      _createVNode("th", _hoisted_49, _toDisplayString(_ctx.$t('allowance')), 1),
                      _createVNode("th", _hoisted_50, _toDisplayString(_ctx.$t('total')), 1)
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.phases, (mainItem, mainItemIndex) => {
                    return (_openBlock(), _createBlock("tbody", { key: mainItemIndex }, [
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_51, [
                          _createVNode("p", _hoisted_52, [
                            _createVNode("strong", null, _toDisplayString(mainItem.name), 1)
                          ])
                        ])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(mainItem.sub_items, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_53, [
                              _createVNode("p", null, _toDisplayString(item.name), 1)
                            ])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_54, [
                              _createVNode("p", null, _toDisplayString(item.description), 1)
                            ])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(item.quantity), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(item.cost), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                          ]),
                          _createVNode("td", null, [
                            (item.markup_type == 1)
                              ? (_openBlock(), _createBlock("p", _hoisted_55, _toDisplayString(item.markup) + " %", 1))
                              : (_openBlock(), _createBlock("p", _hoisted_56, _toDisplayString(item.markup), 1))
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(item.allowance), 1)
                          ]),
                          _createVNode("td", _hoisted_57, [
                            _createVNode("p", null, _toDisplayString(item.total), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]),
              _hoisted_58,
              _createVNode("div", _hoisted_59, [
                _createVNode("div", _hoisted_60, [
                  _createVNode("div", _hoisted_61, [
                    _createVNode("table", _hoisted_62, [
                      _createVNode("tbody", null, [
                        _createVNode("tr", null, [
                          _createVNode("th", _hoisted_63, _toDisplayString(_ctx.$t('total_amount')), 1),
                          _createVNode("th", _hoisted_64, _toDisplayString(_ctx.state.data.details.total), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_65,
              (_ctx.state.data.details.declined_customers && _ctx.state.data.details.declined_customers.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_66, [
                    _createVNode("p", _hoisted_67, [
                      _createVNode("strong", _hoisted_68, _toDisplayString(_ctx.$t('declined_reason')) + ": ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.details.declined_customers[0].reason), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                _createVNode("div", null, [
                  ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement && _ctx.state.data.details.legal_statement))
                    ? (_openBlock(), _createBlock("p", _hoisted_69, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                ((_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement &&
                                        _ctx.state.data.companyInfo.legal_statement) || (_ctx.state.data.details && _ctx.state.data.details.acknowledgement &&
                                            _ctx.state.data.details.legal_statement)
                                    )
                  ? (_openBlock(), _createBlock("div", _hoisted_70, [
                      _createVNode("div", _hoisted_71, [
                        _createVNode("ul", _hoisted_72, [
                          _createVNode("li", _hoisted_73, [
                            _createVNode("button", _hoisted_74, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                          ]),
                          _createVNode("li", _hoisted_75, [
                            _createVNode("button", _hoisted_76, _toDisplayString(_ctx.$t('legal_statement')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_77, [
                          _createVNode("div", _hoisted_78, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.details?.acknowledgement || _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ]),
                          _createVNode("div", _hoisted_79, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.details?.legal_statement || _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_80, [
                _createVNode("p", _hoisted_81, [
                  _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                ])
              ]),
              _createVNode("div", null, [
                _createVNode("p", _hoisted_82, [
                  _hoisted_83,
                  _createTextVNode(" " + _toDisplayString(_ctx.state.data.channel), 1)
                ])
              ]),
              _createVNode("div", _hoisted_84, [
                _createVNode("div", _hoisted_85, [
                  _createVNode("p", _hoisted_86, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('signatures')) + ":", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_87, [
                  (_ctx.state.data.details.signature)
                    ? (_openBlock(), _createBlock("div", _hoisted_88, [
                        _createVNode("div", _hoisted_89, [
                          _createVNode("img", {
                            src: _ctx.state.data.details.signature,
                            alt: ""
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('sender')) + ":", 1)
                        ]),
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                          _createTextVNode(_toDisplayString(_ctx.state.data.details.signature_date), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.details.singed_customers, (customer, customerIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4",
                      key: customerIndex
                    }, [
                      _createVNode("div", _hoisted_90, [
                        _createVNode("img", {
                          src: customer.signature,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_91, _toDisplayString(_ctx.$t('customer')) + ": ", 1),
                        _createTextVNode(_toDisplayString(customer.name
                                                ?
                                                customer.name : customer.email), 1)
                      ]),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('date')) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(customer.signaute_date), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_92, [
            (_ctx.state.data.details.pdf_link)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "btn default-btn mr-2",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                }, [
                  _hoisted_93,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('print')) + "t", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.details.pdf_link)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  href: "javascript:void(0)",
                  class: "btn default-btn outline",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downoadPdf(_ctx.state.data.details.pdf_link)))
                }, [
                  _hoisted_94,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('download')), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode("button", _hoisted_95, _toDisplayString(_ctx.$t('close')), 1)
          ])
        ])
      ])
    ])
  ]))
}